import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

// COMPONENTS
import { CanOrNotFound } from 'permissions';
import PaymentTerms from './PaymentTerms';
import FleetSettingsPaymentDetails from './PaymentDetails/PCIPaymentDetails';

// STYLES
import { SettingsPageContent } from 'styles/settings';

// CONSTANTS
import { DotAppRoute, FleetSettingsSideMenuItem, UserPermission } from 'constants/common';

const FleetSettingsPaymentView = () => {
  const intl = useIntl();

  return (
    <CanOrNotFound I={UserPermission.VIEW} a={DotAppRoute.SETTINGS} field={FleetSettingsSideMenuItem.PAYMENT}>
      <SettingsPageContent>
        <Helmet>
          <title>{intl.formatMessage({ id: 'views.Settings.helmetTitle' })}</title>
          <meta name="payment" content={intl.formatMessage({ id: 'views.Settings.helmetDescription' })} />
        </Helmet>
        <PaymentTerms />
        <FleetSettingsPaymentDetails />
      </SettingsPageContent>
    </CanOrNotFound>
  );
};

export default FleetSettingsPaymentView;
